import { formatDataLayerSlug } from '@awaze/mfe-common.contexts.tms'
import { IPageModuleFieldsExtended } from 'contentful/client/contentful-client-helpers'
import { BlogData } from 'pages/static/module/[...slug]'
import { BlogTag } from '@/components/BlogTags/mapBlogTag'
import { getAuthorName, getBlogData } from 'src/utils/blog/blog-utils'

interface UtagData {
  awazeHttpHeadersSlug: string
  pageType: string
  blogData: BlogData
}

export const getUtagData = ({
  awazeHttpHeadersSlug,
  pageType,
  blogData,
}: // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
UtagData) => {
  if (pageType?.toLowerCase() === 'blog') {
    if (blogData?.author) {
      return {
        page_type: 'blog article',
        page_section: 'blog',
        page_name: blogData.title,
        page_content_category: blogData.blogTags
          ?.map(({ tagName }) => tagName)
          .join(', '),
        page_content_read_time: `${blogData.timeToRead} min`,
        page_content_author: getAuthorName(blogData?.author),
        page_content_publish_date: blogData.createdAt,
        page_content_modified_date: blogData.updatedAt,
      }
    } else {
      return {
        page_type: 'blog category',
        page_section: 'blog',
        page_name: awazeHttpHeadersSlug?.replace(/blog\/|-/g, (match) =>
          match === 'blog/' ? '' : ' ',
        ),
      }
    }
  } else if (awazeHttpHeadersSlug === 'blog') {
    return {
      page_type: 'blog overview',
      page_section: 'blog',
      page_name: 'overview',
    }
  } else if (awazeHttpHeadersSlug === '/') {
    return {
      page_name: 'homepage',
      page_section: 'shop',
      page_type: 'homePage',
    }
  }

  return {
    page_name: formatDataLayerSlug(awazeHttpHeadersSlug),
    page_section: 'shop',
    page_type: mapPageType(pageType?.toLowerCase()) || 'uncategorized',
  }
}

export const getUtagDataForBlogPage = (
  content: IPageModuleFieldsExtended,
): {
  author: string
  timeToRead: number
  blogTags: BlogTag[]
  createdAt: string
  updatedAt: string
  title: string
} => {
  const { timeToRead, blogTags, title } = getBlogData(content)
  return {
    author: content.author,
    timeToRead,
    blogTags,
    createdAt: content.createdAt,
    updatedAt: content.updatedAt,
    title,
  }
}

export const mapPageType = (pageType: string): string => {
  return pageType == 'homepage' ? 'homePage' : `${pageType}Page`
}
